module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_simple_cuad_6.c2f6342c.png";